import React, { Component } from "react";
import ReactTooltip from "react-tooltip";

export default class OptionInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            size: props.size,
            title: props.title,
            hidden: props.hidden,
            editable: props.editable,
            type: props.type,
            label: props.label,
            minValue: props.minValue,
            maxValue: props.maxValue,
            minLength: props.minLength,
            maxLenght: props.maxLenght,
            required: props.required,
            nullable: props.nullable,
            debitable: props.debitable,
            format: props.format,
            options: props.options,
            selected: "",
            elementosCombo: this.cargar(),
        }

    };


    componentDidMount() {

    }
    cargar = () => {

        var data = JSON.stringify(this.props.options);
        var jsonData = JSON.parse(data);

        var elementos = []
      
        for (var i = 0; i < jsonData.length; i++) {
            var valor = JSON.stringify(jsonData[i].option);

            var jsonOption = JSON.parse(valor);
            for (var j = 0; j < jsonOption.length; j++) {
                elementos.push({
                    value: jsonOption[j].value,
                    label:
                        jsonOption[j].name
                })
            }
        }
        //console.log("OPCIONES: "+JSON.stringify(elementos))

        return elementos;
    };



    handleChangeSelector = (event) => {
        const valueToParse = event.target.value;
       
        this.setState({ selected: valueToParse });
        this.props.inputValue(valueToParse, this.props.name, false, "", "OPTION", this.props.label);
        //console.log("VALOR SELECCIONADO COMBO " + valueToParse)
      }

    render() {
        var valores = this.state.elementosCombo




        return (
            <div className="form-group">
                <label className="input-label" data-tip={this.props.title} >
                    <i className="fas fa-question-circle" style={{ fontSize: "25px", color: "#9c9c9c" }}></i> {this.props.label}
                </label>

                <select name={this.props.name} id={this.props.name}
                    required={this.props.required}
                    value = {this.props.value}
                    onChange={this.handleChangeSelector}
                    className="form-control input-box">
                        <option value="">Seleccione</option>
                    {valores.map(elemento => (
                        <option key={elemento.value} value={elemento.value}>
                            {elemento.label}
                        </option>
                    ))}
                </select>

                <ReactTooltip />
            </div>
        )

    }
}